export default "/images/4c75178183107d9977cdf9d66aff9ed3.avif";